import React from 'react';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import DownloadingIcon from '@mui/icons-material/Downloading';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import ErrorIcon from '@mui/icons-material/Error';

export const LIMIT = 50;

export const INITIAL_VALUES = {
  serial_number: '',
  device_model: '',
  device_type: '',
  event_type: [],
  firmware_file: '',
  from_version: '',
  to_version: '',
  has_new: '',
  allowed: '',
  status_code: '',
  only_errors: '',
  channel: '',
  from: null,
  to: null,
};

export const EVENT_TYPES = {
  check: {
    label: 'Проверка версии',
    icon: <ManageSearchIcon className="text-gray-500" />,
  },
  download_started: {
    label: 'Начало загрузки',
    icon: <CloudDownloadIcon className="text-blue-500" />,
  },
  download_chunk: {
    label: 'Загрузка',
    icon: <DownloadingIcon className="text-blue-500" />,
  },
  download_completed: {
    label: 'Загрузка завершена',
    icon: <CloudDoneIcon className="text-green-500" />,
  },
  error: {
    label: 'Ошибка',
    icon: <ErrorIcon className="text-red-500" />,
  },
};

export const EVENT_TYPE_OPTIONS = Object.entries(EVENT_TYPES).map(([value, { label, icon }]) => ({
  value,
  name: label,
  icon,
}));

export const DEVICE_TYPE_OPTIONS = [
  { value: 'colibri', label: 'Colibri' },
  { value: 'esp32', label: 'ESP32' },
];

export const BOOL_OPTIONS = [
  { value: 'true', label: 'Да' },
  { value: 'false', label: 'Нет' },
];

export const CHANNEL_OPTIONS = [
  { value: 'stable', label: 'Стабильный' },
  { value: 'test', label: 'Тестовый' },
];

export const DEFAULT_SORT = {
  sortBy: 'created_at',
  sortOrder: 'desc',
};
